import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { get } from 'lodash';
import PlayerControl from './PlayerControl';
import { getFormattedCurrentTime, isPreviousVideoWatched } from './demoVideoUtils';
import { JPLAYLISTS_PLAYLIST_ITEM_TYPE } from './demoVideoConstants';

const ProgressBar = props => {
    const {
        activeVideoId,
        demoVideosProgress,
        controlType,
        playlist,
        demoVideosDuration,
        playPlaylistWithTracking,
    } = props;
    const currentTime = getFormattedCurrentTime(Object.values(demoVideosProgress));
    const totalTime = `/${demoVideosDuration}`;

    return (
        <div className={classNames('all-videos-progress-container', activeVideoId)}>
            <PlayerControl type={controlType} playPlaylist={playPlaylistWithTracking} />
            <div
                className="progress-container"
                aria-label="Video player progress bar"
                role="progressbar"
                aria-valuemin="0"
                aria-valuemax="100"
            >
                {playlist.playlist.map((entry, index) => {
                    const video = demoVideosProgress[entry.demoVideoId];
                    const isNotFirst = index !== 0;
                    const onClick = () => props.playPlaylist(index);
                    const className = `progress-bar ${isNotFirst ? 'answering' : 'reading'}`;
                    const isEnabled =
                        !isNotFirst ||
                        isPreviousVideoWatched(
                            demoVideosProgress,
                            playlist.playlist[index - 1].demoVideoId,
                        );
                    const currentVideoProgress = get(video, 'progress', 0);
                    return (
                        <React.Fragment key={entry.demoVideoId}>
                            {isNotFirst && (
                                <div
                                    className="separator"
                                    role="separator"
                                    aria-label="Video separator"
                                />
                            )}
                            <div
                                className={classNames(className, { disabled: !isEnabled })}
                                onClick={onClick}
                            >
                                <div
                                    className="bar"
                                    role="progressbar"
                                    aria-valuenow={currentVideoProgress}
                                    style={{ width: `${currentVideoProgress}%` }}
                                />
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
            <div className="current-time" role="note" aria-label={`Current time: ${currentTime}`}>
                {currentTime}
            </div>
            {demoVideosDuration && (
                <div className="total-time" role="note" aria-label={`Total time: ${totalTime}`}>
                    {totalTime}
                </div>
            )}
        </div>
    );
};

ProgressBar.propTypes = {
    activeVideoId: PropTypes.string,
    playPlaylist: PropTypes.func.isRequired,
    controlType: PropTypes.string.isRequired,
    demoVideosProgress: PropTypes.object.isRequired,
    demoVideosDuration: PropTypes.string,
    playlist: JPLAYLISTS_PLAYLIST_ITEM_TYPE.isRequired,
    playPlaylistWithTracking: PropTypes.func,
};

ProgressBar.defaultProps = {
    activeVideoId: '',
    demoVideosDuration: undefined,
    playPlaylistWithTracking: () => {},
};

export default ProgressBar;
